import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

const FilterCategoryButton = () => {
    const selectCategory = useSelector(state => state.initial.selectCategory)
    const { currentCategory, objCateData } = useSelector(state => state.category)
    const mall_web_user = useSelector(state => state.initial?.minishopInfo?.mall_web_user)
    const basicLink = mall_web_user ? `/${mall_web_user}` : ''
    const selectCate = { ...currentCategory.reduce }
    const selectCateArr = [currentCategory.cate[0].cate_id,
        ...Object.keys(selectCate).map(v => selectCate[v]).filter(v => v)
    ]   // 대분류 포함된 selectcategory id array
    const prevSelectCate = selectCateArr[selectCateArr.length - 2]  // selectcategory 이전 카테고리id
    const prev2SelectCate = selectCateArr[selectCateArr.length - 3]  // selectcategory 이전전 카테고리id

    const history = useHistory()

    const onClickBtn = () => {
        if (!objCateData) return
        if (objCateData[prevSelectCate]?.f_clk) {
            history.push(`${basicLink}/list/${objCateData[prevSelectCate].cate_id}`)
        } else {
            if (objCateData[prev2SelectCate]?.f_clk) {
                history.push(`${basicLink}/list/${objCateData[prev2SelectCate].cate_id}`)
            }
            return false
        }
    }

    return (
        <button type="button" className="pic" onClick={onClickBtn}>
            카테고리 : {objCateData && objCateData[selectCategory]?.cate_name} <i className="icon-close"/>
        </button>
    )
}

export default FilterCategoryButton



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_category_button.js